module.exports = __webpack_public_path__ + "static/media/matilde-special-adventour-angry.9384e31b.png";